// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ":root{--navbar-width: 256px}.flag-list svg{width:20px;height:auto;border-radius:3px}.language-selector button.btn{background-color:var(--colors-white);display:flex;align-items:center;box-shadow:var(--shadows-xs);gap:0.75rem;box-shadow:var(--shadows-sm);min-height:36px;border:1px solid var(--colors-gray-300)}.language-selector button.btn::after{color:var(--colors-gray-400)}.language-selector button.btn>.show-flag svg{width:25px;border-radius:3px}\n", ""]);
// Exports
module.exports = exports;
